import Event from '../event';
import customIsoString from 'utilities/custom-iso-string';

/**
 * Create the action
 */

const { thunk, request, success, error } = Event.index((data, fetch, dispatch, getState) => {

    let agenda = getState().agenda;

    return fetch.post('event-timeperiod', {
        start: customIsoString(agenda.start, true),
        end: customIsoString(agenda.end, true),
    });
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
